import React from 'react';

import { Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import styles from './styles.module.scss';

export const FromGroup: React.FC<Partial<React.ComponentProps<typeof Space>>> = ({ children, size = 16, ...props }) => {
  const isMobile = useIsMobile();
  return (
    <Space {...props} size={size} className={styles.group} direction={isMobile ? 'vertical' : 'horizontal'}>
      {children}
    </Space>
  );
};
